export const IS_EA = process.env.REACT_APP_NAME === 'EA';
export const IS_ECC = process.env.REACT_APP_NAME === 'ECC';
